import { URLAnalysis } from "@/types/seo";

interface MetricsFormatterProps {
  mainAnalysis: URLAnalysis;
}

export const formatMetrics = ({ mainAnalysis }: MetricsFormatterProps) => {
  const metrics = [
    {
      title: "Tamanho do Título",
      value: mainAnalysis.title_length,
      benchmark: 60,
    },
    {
      title: "Tamanho da Descrição",
      value: mainAnalysis.description_length,
      benchmark: 160,
    },
    {
      title: "Tamanho do Conteúdo",
      value: mainAnalysis.content_length,
      benchmark: 1000,
    },
  ];

  return metrics;
};

export const formatChecklist = ({ mainAnalysis }: MetricsFormatterProps) => {
  const { boolean_criteria, title_length } = mainAnalysis;
  
  const checklist = [
    {
      title: "Tamanho do Título Adequado",
      passed: title_length >= 50 && title_length <= 60,
      description: "O título tem o comprimento adequado para SEO (entre 50-60 caracteres)",
    },
    {
      title: "Palavra-chave no Título",
      passed: boolean_criteria.keyword_in_title,
      description: "A palavra-chave principal está presente no título da página",
    },
    {
      title: "Palavra-chave na Meta Descrição",
      passed: boolean_criteria.keyword_in_meta,
      description: "A palavra-chave principal está presente na meta descrição",
    },
    {
      title: "Palavra-chave no Início do Título",
      passed: boolean_criteria.keyword_in_title_left,
      description: "A palavra-chave está posicionada no início do título",
    },
    {
      title: "Palavra-chave no Primeiro Parágrafo",
      passed: boolean_criteria.keyword_in_first_paragraph,
      description: "A palavra-chave aparece no primeiro parágrafo do conteúdo",
    },
    {
      title: "Único H1 na Página",
      passed: boolean_criteria.has_single_h1,
      description: "A página possui apenas um título H1",
    },
    {
      title: "Palavra-chave no H1",
      passed: boolean_criteria.keyword_in_h1,
      description: "A palavra-chave está presente no título H1",
    },
    {
      title: "Palavra-chave no H2",
      passed: boolean_criteria.keyword_in_h2,
      description: "A palavra-chave está presente em algum subtítulo H2",
    },
    {
      title: "Palavra-chave no H3",
      passed: boolean_criteria.keyword_in_h3,
      description: "A palavra-chave está presente em algum subtítulo H3",
    },
    {
      title: "URL Limpa",
      passed: boolean_criteria.clean_url,
      description: "A URL é limpa e amigável para SEO",
    },
    {
      title: "Palavra-chave na URL",
      passed: boolean_criteria.keyword_in_url,
      description: "A palavra-chave está presente na URL da página",
    },
    {
      title: "Protocolo HTTPS",
      passed: boolean_criteria.is_https,
      description: "O site utiliza protocolo HTTPS para segurança",
    },
  ];

  return checklist;
};